class CheckBrowserController {
    constructor(HttpHelper, ngProgressFactory) {
        this.init = () => {
            this.data = Object();
            this.traceProgress = this.ngProgressFactory.createInstance();
            // Start nav progress bar
            this.traceProgress.start();
            // instantiate state and data objects
            this.state = {
                supported: undefined
            };
            this.data = {
                browser: new Object(),
                browserList: {
                    browser: new Object()
                },
                bList: undefined
            };
            this.getRecentBrowsers().then((response) => {
                let aBrowser = this.getBrowser();
                this.data.browser.name = aBrowser.name;
                this.data.browser.version = aBrowser.version;
                if (response) {
                    if (response.data) {
                        this.data.bList = _.values(response.data.agents);
                        let anArray = this.filterBrowsers(_.values(response.data.agents));
                        if (anArray !== undefined) {
                            this.data.browserList.browser = [new Object(0)];
                            for (let i = 0; i < anArray.length; i++) {
                                this.data.browserList.browser.push(anArray[i]);
                            }
                            let newArray = new Array();
                            for (let i = 0; i < this.data.browserList.browser.length; i++) {
                                if (this.data.browserList.browser[i]) {
                                    if ((this.data.browserList.browser[i].previous_version === undefined) &&
                                        (this.data.browserList.browser[i].browser !== 'IE' && this.data.browserList.browser[i].browser !== 'Internet Explorer')) {
                                        this.data.browserList.browser[i].previous_version = Number(this.data.browserList.browser[i].current_version) - 1;
                                    }
                                    newArray.push(this.data.browserList.browser[i]);
                                }
                            }
                            delete this.data.browserList.browser[0];
                            this.data.browserList.browser = this.cleanArray(this.data.browserList.browser);
                        }
                        this.checkBrowser(this.data.browser);
                        // Swap out IE to Internet Explorer
                        if (this.data.browser.name === 'IE') {
                            this.data.browser.name = 'Internet Explorer';
                        }
                        this.traceProgress.complete();
                    }
                    this.traceProgress.complete();
                }
                this.traceProgress.complete();
            }, () => {
                this.traceProgress.complete();
                return;
            });
        };
        this.getRecentBrowsers = () => {
            return this.httpHelper.getWithoutCustomHeaders('https://raw.githubusercontent.com/Fyrd/caniuse/master/fulldata-json/data-2.0.json', true);
        };
        this.getBrowser = () => {
            // Use the userAgent to find the browser name and version (it will tell us all about itself)
            let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: (tem[1] || '') };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem !== null) {
                    return { name: 'Opera', version: tem[2] };
                }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                M.splice(1, 1, tem[1]);
            }
            if (M[0] !== undefined) {
                if (M[1] !== undefined) {
                    return {
                        name: M[0],
                        version: M[1]
                    };
                }
                return {
                    name: M[0],
                    version: 'Unknown'
                };
            }
            return {
                name: M[0],
                version: 'Unknown'
            };
        };
        this.filterBrowsers = (browserList) => {
            let blist;
            let filteredBrowserList = this.cleanArray(this.filterBrowserList(browserList));
            // Set the previous version dynamically
            _.forEach(filteredBrowserList, (browser) => {
                if (browser.version_list !== undefined) {
                    let prevVersion = '';
                    for (let j = 0, len = browser.version_list.length; j < len; j++) {
                        if (browser.version_list[j].era === -1) {
                            if (browser.browser !== 'IE' && browser.browser !== 'Internet Explorer') {
                                browser.previous_version = browser.version_list[j].version;
                            }
                        }
                    }
                }
            });
            return this.getBList(filteredBrowserList);
        };
        this.filterBrowserList = (browserList) => {
            let filtList = [new Object(0)];
            if (browserList !== undefined) {
                for (let i = 0; i < browserList.length; i++) {
                    if (browserList[i].browser === 'Firefox' ||
                        browserList[i].browser === 'IE' ||
                        browserList[i].browser === 'Edge' ||
                        browserList[i].browser === 'Chrome') {
                        filtList.push(browserList[i]);
                    }
                }
            }
            return filtList;
        };
        this.getBList = (browserList) => {
            // Create a new object with the data
            if (browserList !== undefined) {
                for (let i = 0; i < browserList.length; i++) {
                    if (browserList[i].browser === undefined) {
                        delete browserList[i];
                    }
                    else {
                        // Replace IE with Internet Explorer
                        if (browserList[i].browser === 'IE') {
                            // We do not want the v10 to be supported.
                            if (Number(browserList[i].currentVersion) > 11) {
                                browserList[i].browser = 'Internet Explorer';
                                browserList[i].currentVersion = browserList[i].currentVersion;
                                browserList[i].Previous_Version = browserList[i].previous_version !== undefined ? browserList[i].previous_version : Number(browserList[i].currentVersion - 1);
                            }
                        }
                    }
                }
            }
            browserList = this.cleanArray(browserList);
            return browserList;
        };
        this.checkBrowser = (browser) => {
            // If we dont have a browser or we dont have a list of browsers there is nothing to check!
            if (browser === undefined || this.data.browserList.browser.length === 0) {
                return;
            }
            // Default to unsupported and change when we find a match
            this.state.supported = false;
            // Look for our browser in the list (check both versions of it though!)
            let match = _.find(this.data.browserList.browser, (supportedBrowser) => {
                if (browser.name === supportedBrowser.browser && (browser.version === supportedBrowser.current_version ||
                    ((supportedBrowser.previous_version !== undefined && browser.version === supportedBrowser.previous_version) ||
                        (supportedBrowser.previous_version === undefined && Number(browser.version) === Number(supportedBrowser.current_version - 1))))) {
                    return supportedBrowser;
                }
                else {
                    return new Object();
                }
            });
            // If we found it then we support it!
            if (match !== undefined) {
                this.state.supported = true;
            }
            return;
        };
        // Clean up array by cleaning up redundant null array entries (after array entry deletion)
        this.cleanArray = (array) => {
            let newArray = new Array();
            for (let i = 0; i < array.length; i++) {
                if (array[i]) {
                    newArray.push(array[i]);
                }
            }
            return newArray;
        };
        this.$onInit = () => {
            this.init();
        };
        this.httpHelper = HttpHelper;
        this.ngProgressFactory = ngProgressFactory;
    }
}
angular.module('app').component('checkBrowser', {
    bindings: {},
    templateUrl: 'scripts/app/partials/CheckBrowser/CheckBrowser.tpl.html',
    controllerAs: 'vm',
    controller: CheckBrowserController
});
